import { useState, useCallback } from 'react';
import api from '../services/api';

export function useKYC() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // USER: Submit KYC documents
  const submitKYC = useCallback(async (formData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.upload('/users/kyc', formData);
      return response;
    } catch (err) {

      const msg = err.response?.data?.message || 'Erreur lors de la soumission KYC';
      setError(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  }, []);

  // USER: Get own KYC status
  const getKYCStatus = useCallback(async () => {
    setLoading(true);
    try {
      // kyc_status is included in the JWT token/user context
      // This endpoint gets the fresh user profile
      const response = await api.get('/auth/profile');

      return response.data;
    } catch (err) {
      return { success: false, message: 'Erreur' };
    } finally {
      setLoading(false);
    }
  }, []);

  // ADMIN/MANAGER: Get pending KYC list
  const getPendingKYC = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/users?kyc_status=pending&limit=100');
      return response.data;
    } catch (err) {
      return { success: false, message: 'Erreur' };
    } finally {
      setLoading(false);
    }
  }, []);

  // ADMIN/MANAGER: Verify or reject a KYC
  const verifyKYC = useCallback(async (userId, status, notes = '') => {
    setLoading(true);
    try {
      const response = await api.put(`/admin/kyc/verify/${userId}`, { status, notes });
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || 'Erreur lors de la vérification';
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, submitKYC, getKYCStatus, getPendingKYC, verifyKYC };
}
